module.exports = __webpack_public_path__ + "static/img/las-fabricas-don-tomaso.0182cd7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/las-fabricas-don-tomaso.gif
// module id = 133
// module chunks = 1